import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Configure marked options
marked.setOptions({
  breaks: true, // Adds <br> on single line breaks
  gfm: true,    // GitHub Flavored Markdown
});

const MarkdownRenderer = ({ content }) => {
  // Convert markdown to HTML and sanitize
  const createMarkup = () => {
    const rawMarkup = marked(content || '');
    const sanitizedMarkup = DOMPurify.sanitize(rawMarkup);
    return { __html: sanitizedMarkup };
  };

  return (
    <div 
      className="prose prose-invert prose-sm max-w-none
        prose-headings:font-medium 
        prose-h1:text-xl prose-h1:mb-4
        prose-h2:text-lg prose-h2:mb-3
        prose-h3:text-base prose-h3:mb-2
        prose-p:text-gray-300 prose-p:mb-2
        prose-ul:my-2 prose-li:my-0
        prose-code:text-blue-400 prose-code:bg-blue-500/10 prose-code:px-1 prose-code:rounded
        prose-pre:bg-dark-hover prose-pre:p-3 prose-pre:rounded-lg
        prose-a:text-blue-400 prose-a:no-underline hover:prose-a:underline
        prose-strong:text-white
        prose-blockquote:border-gray-700 prose-blockquote:bg-dark-hover/50 prose-blockquote:py-0.5 prose-blockquote:px-3
      "
      dangerouslySetInnerHTML={createMarkup()}
    />
  );
};

export default MarkdownRenderer; 